(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsGenericSearchSelect', rmsGenericSearchSelect);

    function rmsGenericSearchSelect(lodash, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                onChange: '=',
                label: '=',
            },
            controller: rmsGenericSearchSelectCtrl,
            controllerAs: "vm",
            templateUrl: 'common/app/components/generic-search-select',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.setModelValue = setModelValue;

                scope.$watch('options', function (newValue, oldValue) {
                    vm.options = newValue;
                    vm.filterOptions();
                });

                ctrl.$render = function () {
                    vm.selected = ctrl.$viewValue;
                };

                function setModelValue(value) {
                    return ctrl.$setViewValue(value);
                }
            }
        };
    }

    function rmsGenericSearchSelectCtrl($scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.options = $scope.options;
            vm.availableOptions = vm.options.slice();
            vm.label = $scope.label;
            vm.selected = null;
            vm.searchText = '';
            vm.dropdownActive = false;

            vm.toggleDropdown = toggleDropdown;
            vm.selectOption = selectOption;
            vm.filterOptions = filterOptions;
        }

        function filterOptions() {
            $timeout(function () {
                if (vm.searchText.length === 0) {
                    return vm.availableOptions = vm.options.slice();
                }
                vm.availableOptions = vm.options.slice().filter(function (item) {
                    var textConcat = lodash.get(item, 'text_concat', '');
                    var label = lodash.get(item, 'label', '');
                    return label.toLowerCase().includes(vm.searchText.toLowerCase()) || textConcat.toLowerCase().includes(vm.searchText.toLowerCase());
                });
            });
        }

        function toggleDropdown(state) {
            return vm.dropdownActive = state;
        }

        function selectOption(option) {
            // vm.availableOptions = vm.availableOptions.filter(function(item) {
            //    return item.id !== option.id;
            // });
            vm.setModelValue(option);
            $scope.onChange();
        }
    }
})();